<div class="lds-hourglass"
[style.--width1]=" width+ 'px'"
[style.--thickness]=" thickness+ 'px'"
[style.--primaryColor]="primaryColor "
[style.--secondaryColor]="secondaryColor "></div>